import { render, staticRenderFns } from "./TrademarkObjectionToUsDecisionForm.vue?vue&type=template&id=9398fc08&"
import script from "./TrademarkObjectionToUsDecisionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsDecisionForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsDecisionForm.vue?vue&type=style&index=0&id=9398fc08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports